import { Component, Input} from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { Router } from '@angular/router';
/**
 * fc-progresspercentç¾åæ¯è¿åº¦æ¡
 * 
 * å±ç¤ºæä½çå½åè¿åº¦ã
 * 
 * å½ä¸ä¸ªæä½ä¼ææ­å½åçé¢ï¼æèéè¦å¨åå°è¿è¡ï¼ä¸èæ¶å¯è½è¶è¿2ç§æ¶ã
 * 
 * å½éè¦æ¾ç¤ºä¸ä¸ªæä½å®æçç¾åæ¯æ¶ã
 * 
 */
@Component({
    selector: 'fc-progresspercent',
    template: `
    <nz-progress [nzPercent]="_percent" nzType="circle" [nzWidth]="_stroWidth"></nz-progress>
    `,
    styles: [`
    `]
})
export class FcprogresspercentComponent extends FcinputComponent {
       /**ç¾åæ¯*/
    @Input()
    fcPercent:string;
    _percent:number;
      /**åå½¢è¿åº¦æ¡çº¿çå®½åº¦ï¼åä½æ¯è¿åº¦æ¡ç»å¸å®½åº¦çç¾åæ¯*/
     @Input()
     fcStrokeWidth:string;
     _stroWidth:number;
    constructor(public provider: ProvidersService, private router: Router) {
        super(provider,'fc-progresspercent');
        if(this.fcStrokeWidth === undefined){
            this._stroWidth = 132;
        }
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
    }
    _afterParentInit(){
         /**å°ç¾åæ¯è½¬æå­ç¬¦ä¸²*/
        if(this.fcPercent){
            this._percent = parseInt(this.fcPercent)
        }
        if(this.fcStrokeWidth){
            this._stroWidth = parseInt(this.fcStrokeWidth)
        }
    }
}
